<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Item</em>
				<span class="int_type" style="width:350px;">
					<AC ref="ac" :source="selectItems" @selected="selectItem" results-display="code_name" placeholder="Item / Class Name or Code"> </AC>
				</span>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<em class="lt_text">Barcode</em>
				<span class="int_type_no_border mgr_5"><input type="text" class="r_int long_type al_left" v-model.trim="barcode" @focus="$event.target.select()"/></span>
				<em class="lt_text">PO</em>
				<span class="int_type_no_border mgr_5"><input type="text" class="r_int long_type al_left" v-model.trim="po" @focus="$event.target.select()"/></span>
				<em class="lt_text">CTN</em>
				<span class="int_type_no_border mgr_5"><input type="text" class="r_int long_type al_left" v-model.trim="ctn" @focus="$event.target.select()"/></span>
				<em class="lt_text">Pieces</em>
				<span class="int_type_no_border mgr_5" style="width:50px;"><input type="text" class="r_int al_right" style="width:45px;" v-model.trim="pieces" @focus="$event.target.select()" @input="onPiecesInput"/></span>

				<a href="javascript:void(0);" class="search_bt" @click="reportPrint()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetReportTemplate, companyMrtUrl, Report } from '@/api/util';
import { apiSelectItemByBarcode } from '@/api/item/master';
import AC from '@/components/common/AC';

export default {
	data: function() {
		return {
			barcode: '',
			po: '',
			ctn: '',
			pieces: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: { AC },
	methods: {
		reset() {
			this.barcode = '';
			this.pieces = '';
			this.$refs.ac.clear();
		},
		onPiecesInput() {
			this.pieces = this.pieces.replace(/[^0-9]/g, '');
		},
		selectItems(input) {
			return process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectItem(c) {
			const selected = c.selectedObject;
			if (selected.barcode) {
				this.barcode = selected.barcode;
				if (selected.packing) {
					this.pieces = String(selected.packing);
				}
				this.reportPrint();
			}
		},
		async selectData() {
			const { data } = await apiSelectItemByBarcode(this.barcode);
			return data;
		},
		async reportPrint() {
			if (!this.barcode) {
				this.$toast.error('Empty barcode');
				return;
			}

			const data = await this.selectData();
			if (data.value) {
				data.value.ctn = this.ctn;
				data.value.po = this.po;
				if (!this.pieces) {
					this.pieces = data.value.packing;
				}
				data.value.packing = this.pieces;
				const reportTemplate = await apiGetReportTemplate('PackingStatus', companyMrtUrl('label'));
				const report = new Report(reportTemplate, data, 'label');
				this.$store.commit('setReport', report);
			} else {
				this.$toast.error('Item not found');
			}
		},
	},
	created() {
		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_label_print');
		this.$store.commit('setSubTitle', 'Item -> Label Print');
	},
};
</script>

<style></style>
